/**
 * 联系人信息
 * @author Created by jiamei.yao 2017/05/22
 */

'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image} from 'react-native';
import styles from './style';

import BaseInfo from '../../baseInfo/index';

class RankCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let flight = this.props.data || {};

        const {
            labelItem, roundTotalPriceDesc, discount, price
        } = flight || {};
        return  (
            <TouchableOpacity style={styles.cheapSimpleCard} onPress={()=>{this.props.jump(flight)}}>
                {
                    labelItem && (
                        <View
                            style={[styles.label, {backgroundColor: labelItem.bgColor}]}>
                            <Image source={{uri: labelItem.image}}
                                   style={styles.labelImg}/>
                            {labelItem.icon &&
                            <Text style={styles.labelIcon}>{labelItem.icon}</Text>}
                            <Text
                                style={[styles.labelText, {color: labelItem.textColor}]}>{labelItem.text}</Text>
                        </View>
                    )
                }

                <BaseInfo data={flight} config={{subTitleTop: 4}}/>

                <View style={styles.simplePriceField}>
                    {discount ? <Text style={styles.priceDiscount}>{discount}</Text> : null}
                    {roundTotalPriceDesc && !discount ? <Text style={styles.priceDiscount}>{roundTotalPriceDesc}</Text> : null}
                    <View style={[styles.accuratePriceField, styles.simpleAccuratePriceField]}>
                        <Text
                            style={[styles.priceColor, styles.simplePrefixSize]}>&yen;</Text>
                        <Text
                            style={[styles.priceColor, styles.simpleYuanSize]}>{price}</Text>
                    </View>
                </View>
            </TouchableOpacity>
        )
    }
}

export default RankCard;
